import { render, staticRenderFns } from "./pjdy.vue?vue&type=template&id=01857241&scoped=true&"
import script from "./pjdy.vue?vue&type=script&lang=js&"
export * from "./pjdy.vue?vue&type=script&lang=js&"
import style0 from "./pjdy.vue?vue&type=style&index=0&id=01857241&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01857241",
  null
  
)

export default component.exports